module.exports = __webpack_public_path__ + "img/Prepurchased option_Website.5a6cb4f7.jpg";